<template>
  <v-menu offset-y>
    <!-- WARNING: ***this MUST be here for item to be able to render its content. -->
    <!-- NOTE: forces Vue to render this code. -->
    <div class="d-none">
      {{btn}}
    </div>
    <template v-slot:activator="{ on, attrs }">
      
      <v-btn
      :class="`nav-btn text-none ${btn.highlight ?  'nav-item-pushed' : ''}`"
      text
      dark
      v-bind="attrs"
      v-on="on">
        <v-icon 
        size="19"
        class="mr-1">
          {{btn.icon}}
        </v-icon>
        {{$t(btn.label)}}
        <v-icon 
        size="19"
        class="mr-1">
          mdi-menu-down
        </v-icon>
        <notification-badge
        v-if="getNotificationNumber && getNotificationNumber > 0"
        :value="getNotificationNumber"/>
      </v-btn>
    </template>
    <div class="nav-menu-container">
      <v-row 
      no-gutters
      dense
      class="my-2"
      v-for="(c, i) in btn.children"
      :key="i">
        <v-col>
          <!-- NOTE: if this is about to gets used multiple times, export the code in component. -->
          <v-hover
          v-slot="{ hover }">
            <router-link
            v-if="c.link"
            :to="buildUrl(c.link)"
            :class="`d-flex justify-space-between align-center nav-menu-item ${getItemBg(hover || c.highlight)}`">
              <span :style="`color: ${getItemColor(hover || c.highlight)};`">{{$t(c.label)}}</span>
              <notification-badge
              v-if="getNotificationNumberByBtn(c) && getNotificationNumberByBtn(c) > 0"
              :value="getNotificationNumberByBtn(c)"/>
              <mdi-icon v-else-if="c.icon" :src="c.icon" :color="getItemColor(hover || c.highlight)" class="ml-2"/>
            </router-link>
            <div
            v-else
            @click="c.action()"
            :class="`d-flex justify-space-between align-center nav-menu-item ${getItemBg(hover || c.highlight)}`">
              <span :style="`color: ${getItemColor(hover || c.highlight)};`">{{$t(c.label)}}</span>
              <notification-badge
              v-if="getNotificationNumberByBtn(c) && getNotificationNumberByBtn(c) > 0"
              :value="getNotificationNumberByBtn(c)"/>
              <mdi-icon v-else-if="c.icon" :src="c.icon" :color="getItemColor(hover || c.highlight)" class="ml-2"/>
            </div>
          </v-hover>
        </v-col>
      </v-row>
    </div>
  </v-menu>
</template>
<script>
import NotificationBadge from '@/components/common/NotificationBadge'
import MdiIcon from '@/components/btns/MdiIcon'
import { getSelectedLanguage } from '@/services/authService'
export default {
  components: {
    NotificationBadge,
    MdiIcon
  },
  props: {
    btn: Object
  },
  data() {
    return {
    }
  },
  computed: {
    getContact() {
      return this.$contactHolder.get()
    },
    getNotificationNumber() {
      return this.btn.notificationCount !== null && this.btn.notificationCount !== undefined ? this.btn.notificationCount() : null
    }
  },
  methods: {
    buildUrl(l) {
      return `/${getSelectedLanguage()}/${l}`
    },
    getItemColor(hover) {
      return hover ? 'white' : '#00B0E3'
    },
    getItemBg(hover) {
      return hover ? 'nav-menu-item--selected' : ''
    },
    getNotificationNumberByBtn(b) {
      return b.notificationCount !== null && b.notificationCount !== undefined ? b.notificationCount() : null
    }
  }
}
</script>
<style>
.nav-btn.v-btn.v-btn--text.theme--dark {
  font-family: 'Titillium Web', sans-serif;
  font-size: 1.05rem;
  line-height: inherit;
  letter-spacing: 0px;
  font-weight: 300;
  padding: 0px 10px;
}

.nav-menu-container {
  background-color: white;
  padding: 5px 8px;
  width: 100%;
}

.nav-menu-item {
  background-color: white;
  color: black;
  height: 40px;
  padding: 0px 10px;

  font-family: 'Titillium Web', sans-serif;
  font-size: 0.89rem;
  line-height: inherit;
  letter-spacing: 1px;
  font-weight: 300;
  box-shadow: 0px 0px 0px 0px transparent;
}
.nav-menu-item {
  text-decoration: none !important;
}
button.nav-item-pushed {
  background: #8cb9ff !important;
}
.nav-menu-item--selected {
  background-color: #00B0E3;
  height: 40px;
  cursor: pointer;
  border-radius: 3px;
  box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.363);

  font-family: 'Titillium Web', sans-serif;
  font-size: 0.89rem;
  line-height: inherit;
  letter-spacing: 1px;
  font-weight: 300;
}
</style>